import React, { memo, useContext } from "react";

import { DeliverySpeedCallout } from "@swiggy-private/cart-types";
import { AnalyticsContext, AnalyticsContextValue } from "@swiggy-private/checkout-core";
import { useEffectOnce } from "@swiggy-private/core-ui";
import { isEmpty } from "@swiggy-private/js-utils";

import { DELIVERY_SPEED_WIDGET_TEST_IDS } from "@swiggy-private/cart-test-ids";

import { CalloutOuter, CalloutBubble, CalloutMessage } from "./OptionCallout.style";

interface OptionCalloutProps {
    callout: DeliverySpeedCallout;
    impressionDeliverySpeedCallout?: (
        impressionEvent: AnalyticsContextValue["impressionEvent"],
        calloutMessage: string,
    ) => void;
}

function OptionCallout({ callout, impressionDeliverySpeedCallout }: OptionCalloutProps) {
    const { message, message_color: messageColor, background_color: backgroundColor } = callout;
    const { impressionEvent } = useContext(AnalyticsContext);

    useEffectOnce(() => {
        if (isEmpty(message)) {
            return;
        }
        impressionDeliverySpeedCallout?.(impressionEvent, message);
    });

    if (isEmpty(message)) {
        return null;
    }

    return (
        <CalloutOuter data-testid={DELIVERY_SPEED_WIDGET_TEST_IDS.DELIVERY_SPEED_OPTION_CALLOUT}>
            <CalloutBubble bgColor={backgroundColor}>
                <CalloutMessage
                    data-testid={DELIVERY_SPEED_WIDGET_TEST_IDS.DELIVERY_SPEED_OPTION_CALLOUT_MESSAGE}
                    variant="V2.body3.neutral.regular"
                    color={messageColor}
                >
                    {message}
                </CalloutMessage>
            </CalloutBubble>
        </CalloutOuter>
    );
}

export default memo(OptionCallout);
